import React from 'react';
import { Tree as AntTree } from 'antd';

const CustomTree = ({
    treeData,
    onSelect,
    onRightClick,
    showLine,
    showIcon,
    className = 'custom-tree',
}) => {
    return (
        <AntTree
            treeData={treeData}
            onSelect={onSelect}
            onRightClick={onRightClick}
            showLine={showLine}
            showIcon={showIcon}
            className={className}
        />
    );
};

export default CustomTree;